import { SERVER_URL } from "../../../constants";
import { fetchGetAuth } from "../../../util/FetchUtil";

const controller = "cantina-extrato/";

export const findCantinaExtratoByCurrentUser = (page) => {
  const url =
    SERVER_URL + controller + "query-page?type=current-user&page=" + page;
  return fetchGetAuth(url);
};

export const findCantinaExtratoByAlunoCodigo = (codAluno, page) => {
  const url =
    SERVER_URL +
    controller +
    "query-page?cod-aluno=" +
    codAluno +
    "&page=" +
    page;
  return fetchGetAuth(url);
};
